import { Component, OnInit, inject } from '@angular/core';
import {ProfileDataService} from '../profile-data.service';
import {GrowOutAnimation, OpacityInAnimation} from '@exl-ng/mulo-common';
import {UrlUtils} from '../../shared/utils/url.utils';
import { Award } from '../../shared/interfaces/award.interface';
import { DefaultTranslatePipe } from '../../shared/pipes/default-translate.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { CitationBriefComponent } from '../../parts/citations/citation-brief/citation-brief.component';


@Component({
    selector: 'esp-profile-highlights-awards',
    templateUrl: './profile-highlights-awards.component.html',
    styleUrls: ['./profile-highlights-awards.component.scss'],
    animations: [
        GrowOutAnimation,
        OpacityInAnimation
    ],
    imports: [CitationBriefComponent, TranslateModule, DefaultTranslatePipe]
})
export class ProfileHighlightsAwardsComponent implements OnInit {
    profileDataService = inject(ProfileDataService);


    institutionCode = UrlUtils.getParam('institution');

    ngOnInit() {
    }

    getInvestigatorsStr(award: Award){
        return award.investigators.join(', ');
    }
}
